"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const button_1 = __importDefault(require("components/cosmos/button/button"));
const modal_1 = require("components/cosmos/v2/modal");
const translate_1 = require("components/translate");
const mobx_react_1 = require("mobx-react");
const constants_1 = require("modules/app/services/datahub/constants");
const DatahubService_1 = __importDefault(require("modules/app/services/datahub/DatahubService"));
const helper_1 = require("modules/app/services/datahub/helper");
const SchedulerService_1 = __importDefault(require("./SchedulerService"));
const DrippingBulkActionEvents_1 = require("../DrippingBulkActionEvents");
const removeScheduleModal_module_scss_1 = __importDefault(require("./removeScheduleModal.module.scss"));
const sendClickCancelRemoveEvent = () => {
    (0, DrippingBulkActionEvents_1.clickCancelRemove)();
    DatahubService_1.default.sendEvent({
        action: constants_1.EVENT_ACTIONS.INTERACT,
        event: (0, helper_1.buildInteractionEventData)({
            category: constants_1.EVENTS_CATEGORY.CONTENT.CONTENT_SCHEDULE.NAME,
            action: constants_1.EVENTS_INTERACTIONS.CLICK,
            label: constants_1.EVENTS_LABELS.CONTENT.CONTENT_SCHEDULE.CANCEL_REMOVE_DRIPPING
        })
    });
};
const sendClickRemoveEvent = () => {
    (0, DrippingBulkActionEvents_1.clickRemove)();
    DatahubService_1.default.sendEvent({
        action: constants_1.EVENT_ACTIONS.INTERACT,
        event: (0, helper_1.buildInteractionEventData)({
            category: constants_1.EVENTS_CATEGORY.CONTENT.CONTENT_SCHEDULE.NAME,
            action: constants_1.EVENTS_INTERACTIONS.CLICK,
            label: constants_1.EVENTS_LABELS.CONTENT.CONTENT_SCHEDULE.SAVE_REMOVE_DRIPPING
        })
    });
};
const RemoveScheduleModal = ({ open, checkedContent, onClose, onSuccess, isMobile, t }) => {
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const handleKeepSchedule = (e) => {
        e.stopPropagation();
        onClose();
    };
    const handleRemoveSchedule = async () => {
        setIsLoading(true);
        await SchedulerService_1.default.removeDripping(checkedContent);
        setIsLoading(false);
        onClose();
        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
    };
    if (!open) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(modal_1.Modal, { show: true, className: removeScheduleModal_module_scss_1.default.removeScheduleModal, onClose: onClose, children: [(0, jsx_runtime_1.jsx)(modal_1.Modal.Header, { className: "_p-6", children: (0, jsx_runtime_1.jsx)("h3", { className: "_text-4 _text-gray-700 _mb-0", children: t('dripping.remove_dripping.modal.title') }) }), (0, jsx_runtime_1.jsx)(modal_1.Modal.Body, { className: "_py-0", children: (0, jsx_runtime_1.jsx)("p", { className: "_text-2 _text-gray-900 _line-height-lg _my-0", "data-test": "ca-remove-dripping-description", children: t('dripping.remove_dripping.modal.description') }) }), (0, jsx_runtime_1.jsxs)(modal_1.Modal.Footer, { className: "_d-flex _flex-column _flex-md-row _justify-content-md-end _p-6", children: [(0, jsx_runtime_1.jsx)(button_1.default, { ...(isMobile && { size: 'block' }), variation: "tertiary", className: "_mr-0 _mr-md-4", "data-test": "remove-dripping-button-cancel", onClick: handleKeepSchedule, onFocus: sendClickCancelRemoveEvent, children: t('dripping.remove_dripping.modal.keep_schedule') }), (0, jsx_runtime_1.jsx)(button_1.default, { ...(isMobile && { size: 'block' }), className: "_d-flex _align-items-center _justify-content-center", icon: ['fal', 'trash'], loading: isLoading, "data-test": "remove-dripping-button-save", onClick: handleRemoveSchedule, onFocus: sendClickRemoveEvent, children: t('dripping.remove_dripping.title_new') })] })] }));
};
exports.default = (0, mobx_react_1.inject)(({ UiStore }) => ({
    isMobile: UiStore.isMobile
}))((0, translate_1.translate)()(RemoveScheduleModal));
